import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Injector,
  Input,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ConditionComponent } from '../condition/condition.component';

export const CONDICION_VALOR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ValueConditionComponent),
  multi: true,
};

@Component({
  selector: 'value-condition',
  templateUrl: './value-condition.component.html',
  styleUrls: ['./value-condition.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CONDICION_VALOR_VALUE_ACCESSOR],
})
export class ValueConditionComponent
  implements AfterViewInit, ControlValueAccessor
{
  private _text: string;
  initializeMarking: boolean;
  formControlName: any;
  get text(): string {
    return this._text;
  }
  @Input()
  set text(value: string) {
    console.log(value);
    this._text = value;
  }
  value: boolean = false;

  @ViewChild('condition', { static: true }) condition: ConditionComponent;
  constructor(private cdr: ChangeDetectorRef, private injector: Injector) {}

  ngAfterViewInit() {
    this.value = this.condition.value;

    this.formControlName = this.injector.get(FormControlName);

    this.formControlName.valueChanges.subscribe((value) => {
      this.value = value;
      this.condition.changeCondition({
        value: this.value ? this.value : null,
        text: this.text,
      });
      this.cdr.detectChanges();
    });
  }

  // Implementación de ControlValueAccesor
  writeValue(obj: any): void {
    this.condition.writeValue(obj);
  }

  registerOnChange(fn: (_: any) => {}): void {
    this.condition.registerOnChange(fn);
  }

  registerOnTouched(fn: () => {}): void {
    this.condition.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.condition.setDisabledState(isDisabled);
  }
  click() {
    this.value = !this.value;

    this.condition.changeCondition({
      value: this.value ? this.value : null,
      text: this.text,
    });

    this.cdr.detectChanges();
  }
}
